import React from "react";
import { useStreamContext } from "../../context/StreamContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { usePlayerContext } from "../../context/PlayerContext";
import { CButton } from "../../components/UI";
import "./style.scss";

export default () => {
    const { getProperty } = useLocaleContext();
    const { streams, stream: currentStream, setStream } = useStreamContext();
    const { tabletView, currentModule, embedEpisode } = usePlayerContext();

    if (streams.length <= 1 || !!embedEpisode) {
        return null;
    }

    return (
        <div className="stream-tabs-wrapper" id="stream-tabs">
            <div className={`stream-tabs-container ${tabletView && currentModule ? 'scrollable' : ''}`}>
                {streams.map((stream) => (
                    <CButton
                        key={stream.id}
                        size="lg"
                        color={!!stream.color ? stream.color ?? '' : ''}
                        colorFilled={stream.id === currentStream?.id ? (stream.color || "var(--app-color-3)") : ''}
                        label={getProperty(stream, 'description')}
                        onClick={() => setStream(stream)}
                    />
                ))}
            </div>
        </div>
    );
}
